import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';
import { customScrollStyles } from '@gem/ui-kit';

import { useSelectDesktopSharingScreenPopupPresenter } from './SelectDesktopSharingScreenPopup.presenter';
import styles from './SelectDesktopSharingScreenPopup.styles.m.css';

export const SelectDesktopSharingScreenPopup: FC<ICommonPopupsProps> = observer((props) => {
  const presenter = useSelectDesktopSharingScreenPopupPresenter(props);
  const { t } = useTranslation();

  return (
    <Popup
      title={t('common_screen_sharing')}
      isOpened
      onClose={presenter.onClose}
    >
      <div className={classNames(styles.container, customScrollStyles.container)}>
        <div className={styles.grid}>
          {presenter.sources.map((source) => {
            return (
              <button
                key={source.id}
                onClick={(): void => presenter.onSelect(source.id)}
                className={styles.item}
              >
                <div className={styles.imageContainer}>
                  <img
                    src={source.thumbnailUrl}
                    className={styles.image}
                    alt=""
                  />
                </div>
                <p className={styles.title}>{source.name}</p>
              </button>
            );
          })}
        </div>
      </div>
    </Popup>
  );
});
